<template>
	<div class="c-empty flex-column flex-center" :style="{'height': height}">
		<div class="c-empty-icon">
			<img :src="config.icon" />
		</div>
		<div class="c-empty-message">{{config.message}}</div>
	</div>
</template>

<script>
	export default {
		props: {
			type: String,
			height: String,
			message: String
		},

		computed: {
			config() {
				switch(this.type) {
					case 'network':
						return {
							icon: require('@/assets/image/empty/network.png'),
							message: this.message || '当前服务不可用，请稍后重试'
						}
					
					default:
						return {
							icon: require('@/assets/image/empty/common.png'),
							message: this.message || '未查询到相关数据'
						}
				}
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.c-empty {
		min-height: 400px;
		
		&-icon {
			width: 120px;
			height: 120px;
		}

		&-message {
			line-height: 52px;
			font-size: 16px;
			color: #bbb;
			
			elder({
				font-size: 22px
			})
		}
	}
</style>
